import { useDecisionMakerResponsePageData } from 'src/app/pages/decisionMakerResponse/details/pageContext';

type Result = ModelHookResult<{
	showActions: boolean;
	declareVictoryUrl: string;
	postUpdateUrl: string;
}>;

export function useStarterActions(): Result {
	const {
		data: {
			decisionMakerResponse: {
				petition: { slug, viewerCanEdit, status },
			},
		},
	} = useDecisionMakerResponsePageData();

	return {
		data: {
			showActions: viewerCanEdit && !['VICTORY', 'CLOSED'].includes(status),
			declareVictoryUrl: `/p/${encodeURIComponent(slug)}/victory`,
			postUpdateUrl: `/p/${encodeURIComponent(slug)}`,
		},
	};
}
